import { Stack, Text } from '@chakra-ui/react'

import { getArticleUrl } from '@/client/services/url/faq'

import ShwLink from '@/components/ShwLink'
import type { FormBlock } from '@/components/UI/Form/types'

export function getAssentFormInputs(): FormBlock[] {
  const inputs: FormBlock[] = [
    {
      display: 'display',
      type: 'content',
      name: 'assent_explanation',
      content: (
        <Stack spacing="16px">
          <Text>
            We regularly conduct research at Schoolhouse to better understand and improve tutoring.
            We use information you provide—such as feedback, assessments, attendance, and Zoom audio
            or chat—for research. Some data may be shared with trusted research partners (e.g.,
            Stanford University or College Board). Any research results shared publicly will be
            combined or de-identified so you cannot be identified.
          </Text>
          <ShwLink href={getArticleUrl('research-study-details')} isExternal>
            Read more here
          </ShwLink>
        </Stack>
      ),
      size: 6,
    },
    {
      type: 'multi-checkbox',
      name: 'assent_agreement',
      label: 'Agreement',
      options: [
        {
          value: 'agreed',
          label: 'I agree to participate in this program and the data sharing described above.',
        },
      ],
      required: true,
      size: 6,
    },
  ]

  return inputs
}
